function reducer(state, action) {
  switch (action.type) {
    case "upSertTheme": {
      return {
        ...state,
        themes: {
          ...state.themes,
          [action.themeName]: action.theme
        }
      };
    }
    case "removeTheme": {
      const themes = { ...state.themes };
      delete themes[action.themeName];
      return {
        ...state,
        themes
      };
    }
    case "loadTheme": {
      return {
        ...state,
        activeThemeName: action.themeName
      };
    }
  }
}
export {
  reducer
};
//# sourceMappingURL=stateReducer.js.map
